export default "__VITE_ASSET__ChjXJJen__"